import React, { useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import client, { apiErr } from "../lib/api";
import { useApp } from "../context/AppContext";
import { Button, Input, Card } from "../components/ui";
import { ShieldCheck } from "lucide-react";

export default function SetupPassword() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const { login } = useApp();
  const nav = useNavigate();
  const [pw, setPw] = useState("");
  const [pw2, setPw2] = useState("");
  const [recEmail, setRecEmail] = useState("");
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async () => {
    setErr("");
    if (!token) return setErr("Missing setup token. Please use the link from your invitation.");
    if (pw.length < 6) return setErr("Password must be at least 6 characters.");
    if (pw !== pw2) return setErr("Passwords do not match.");
    if (!recEmail.trim()) return setErr("A secondary recovery email is required for account recovery.");
    setBusy(true);
    try {
      const { data } = await client.post("/auth/setup-password", { token, new_password: pw, recovery_email: recEmail.trim() });
      login(data.token, data.user);
      nav("/app");
    } catch (e) { setErr(apiErr(e)); }
    setBusy(false);
  };

  return (
    <div className="grid min-h-screen place-items-center p-6" style={{ background: "var(--app-bg)" }}>
      <Card className="w-full max-w-md space-y-4" data-testid="setup-password">
        <div className="flex items-center gap-2 font-head text-xl"><ShieldCheck size={22} className="text-[var(--primary)]" /> Set up your access</div>
        <p className="text-sm opacity-70">Choose a password and a secondary recovery email to activate your Full Option Family Office account.</p>
        <Input label="New password" type="password" value={pw} onChange={(e) => setPw(e.target.value)} data-testid="setup-new" />
        <Input label="Confirm new password" type="password" value={pw2} onChange={(e) => setPw2(e.target.value)} data-testid="setup-confirm" />
        <Input label="Secondary recovery email (required)" type="email" value={recEmail} onChange={(e) => setRecEmail(e.target.value)} data-testid="setup-recovery-email" />
        <p className="text-xs opacity-50">Used to recover access and to confirm any future change to your email or phone. Use a different address from your login email.</p>
        {err && <div className="text-sm text-[#DA1E28]" data-testid="setup-error">{err}</div>}
        <Button onClick={submit} disabled={busy} data-testid="setup-submit" className="w-full">Set password & sign in</Button>
      </Card>
    </div>
  );
}
